import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useContext } from "react";
import { DarkModeContext } from "./context/darkModeContext";
import { AuthContext } from "./context/AuthContext";
import CustomUrlComponent from "./components/CustomUrl/customUrlComponent";

import Login from "./pages/login/Login";
import Dashboard from "./pages/Dashboard";
import NotFound from "./404";
import Reports from "./pages/Reports";
import AliasPanelRoute from "./AliasPanelRoute"; // Import the AliasPanelRoute

import "./style/dark.scss";
import FilesPage from "./pages/FilesPage";

function ProtectedRoute({ children, requiredCompanyId, requiredLocationId }) {
  const { currentUser } = useContext(AuthContext);

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // If the user is not a companyAdmin and the companyId or locationId doesn't match, block login
  if (
    currentUser.role !== 1 &&
    (currentUser.companyId !== requiredCompanyId ||
      currentUser.locationId !== requiredLocationId)
  ) {
    return <Navigate to="/notfound" replace />;
  }

  // If the user is a companyAdmin, only check companyId
  if (currentUser.role === 2 && currentUser.companyId !== requiredCompanyId) {
    return <Navigate to="/notfound" replace />;
  }

  if (
    currentUser.role === 4 ||
    currentUser.role === 5 ||
    currentUser.role === 7 ||
    currentUser.role === 8
  ) {
    return <Navigate to="/notfound" replace />;
  }

  return children;
}

function App() {
  const { darkMode } = useContext(DarkModeContext);
  const { currentUser } = useContext(AuthContext);

  return (
    <div className={darkMode ? "app dark" : "app"}>
      <BrowserRouter>
        <Routes>
          {/* Default route, redirect to /login */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* Login Route */}
          <Route
            path="/login"
            element={
              currentUser ? (
                <Navigate
                  to={`/${currentUser.companyId}/${currentUser.locationId}/selectWatch`}
                  replace
                />
              ) : (
                <Login />
              )
            }
          />

          {/* Alias Panel Route to handle /locations or custom alias validation */}

          {/* Dashboard Route with companyId and locationId */}
          <Route
            path="/:companyId/:locationId/dashboard/:watchId"
            element={
              <ProtectedRoute
                requiredCompanyId={currentUser?.companyId}
                requiredLocationId={currentUser?.locationId}
              >
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* Reports Route with companyId and locationId */}
          <Route
            path="/:companyId/:locationId/reports/:watchId"
            element={
              <ProtectedRoute
                requiredCompanyId={currentUser?.companyId}
                requiredLocationId={currentUser?.locationId}
              >
                <Reports />
              </ProtectedRoute>
            }
          />

          <Route
            path="/:companyId/:locationId/files/:watchId"
            element={
              <ProtectedRoute
                requiredCompanyId={currentUser?.companyId}
                requiredLocationId={currentUser?.locationId}
              >
                <FilesPage />
              </ProtectedRoute>
            }
          />

          {/* CustomUrlComponent for /selectWatch */}
          <Route
            path="/:companyId/:locationId/selectWatch"
            element={
              currentUser ? (
                <CustomUrlComponent />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />

          {/* 404 Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
